import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

export let ListIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('ListIcon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M15 12h-5" fill="none" />
    <path d="M15 8h-5" fill="none" />
    <path d="M19 17V5a2 2 0 0 0-2-2H4" fill="none" />
    <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" fill="none" />
  </svg>
);
